import { BACKEND_URL, S3_BUCKET } from './environment.js';

//Chech for ENV in ./enviroment.js for running locally
const BASEURL = BACKEND_URL;
const APIURL = `${BACKEND_URL}api/v1`;
// S3_BUCKET points asset reads at whatever object store the environment uses, so an
// on-device MinIO can stand in for the AWS bucket without editing this file.
const S3URL =
  S3_BUCKET || 'https://web-platform-data-dev.s3.ap-northeast-2.amazonaws.com/';

// Dark-launch guard: only the literal boolean true may select owned chat.
const OWNED_CHAT_ENABLED = true;
// Migration-window guard for legacy app webviews. Turn on only after store
// releases are approved and Matrix writes are about to be frozen.
const APP_CHAT_UPDATE_REQUIRED = true;
export { APIURL, APP_CHAT_UPDATE_REQUIRED, BASEURL, OWNED_CHAT_ENABLED, S3URL };
